import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';
import { Loader2, Sparkles, Trash2, ImageIcon } from 'lucide-react';
import { runAiJob } from '../../lib/aiJob';

const STYLES = {
  clasico: 'clásico y sobrio, con un sello o balanza estilizada',
  moderno: 'moderno y minimalista, con un monograma geométrico',
  institucional: 'institucional, con escudo y laureles finos',
};

export const NotaryLogo = ({ hasName }) => {
  const { api } = useAuth();
  const [url, setUrl] = useState(null);
  const [style, setStyle] = useState('clasico');
  const [busy, setBusy] = useState(false);

  const load = () => api.get('/notary-profile/logo', { responseType: 'blob' }).then((r) => setUrl(r.status === 204 || !r.data?.size ? null : URL.createObjectURL(r.data))).catch(() => setUrl(null));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const generate = async () => {
    setBusy(true);
    try {
      await runAiJob(api, '/notary-profile/logo', { style: STYLES[style] }, { timeout: 120000 });
      toast.success('Logo generado: ya aparece en tus finiquitos y ratificaciones');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || e.message || 'No se pudo generar el logo'); } finally { setBusy(false); }
  };
  const remove = async () => { await api.delete('/notary-profile/logo'); setUrl(null); toast.success('Logo eliminado'); };

  return (
    <section data-testid="notary-logo-section" className="bg-slate-900 border border-slate-800 rounded-2xl p-6 space-y-4">
      <div>
        <h2 className="text-lg font-semibold flex items-center gap-2"><ImageIcon className="w-5 h-5 text-amber-400" />Logo y membrete</h2>
        <p className="text-sm text-slate-400">La IA diseña el logo con el nombre y la comuna de tu notaría. Se imprime en el encabezado de finiquitos y ratificaciones.</p>
      </div>
      {url && <img data-testid="notary-logo-preview" src={url} alt="Logo de la notaría" className="w-full max-w-md rounded-lg bg-white" />}
      <div className="flex flex-wrap items-center gap-2">
        <select data-testid="notary-logo-style" value={style} onChange={(e) => setStyle(e.target.value)} className="bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-sm">
          <option value="clasico">Clásico</option><option value="moderno">Moderno</option><option value="institucional">Institucional</option>
        </select>
        <button data-testid="notary-logo-generate-btn" onClick={generate} disabled={busy || !hasName} className="bg-amber-500 text-slate-950 font-semibold rounded-full px-4 py-2 text-sm flex items-center gap-1.5 disabled:opacity-40">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}{url ? 'Generar otro' : 'Generar logo'}
        </button>
        {url && <button data-testid="notary-logo-delete-btn" onClick={remove} className="text-slate-400 hover:text-red-400 flex items-center gap-1 text-sm"><Trash2 className="w-4 h-4" />Quitar</button>}
      </div>
      {!hasName && <p className="text-xs text-slate-500">Guarda primero el nombre del notario arriba.</p>}
    </section>
  );
};
